import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const HomePage = () => {
  const { t } = useTranslation();

  const projects = [
    {
      id: 1,
      title: 'wild cherry',
      link: '/project/wildcherry',
      image:
        'https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/68d3760f45ebf5dca91ec239fe272352.png',
    },
    {
      id: 2,
      title: "le veau d'or",
      link: '/project/leveaudor',
      image:
        'https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/f1b7b09b3699e1a83975b65fbc7fad20.png',
    },
    {
      id: 3,
      title: 'le rock',
      link: '/project/lerock',
      image:
        'https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/85cbb154075f8e015922171d3404e05f.jpeg',
    },
    {
      id: 4,
      title: 'frenchette',
      link: '/project/frenchette',
      image:
        'https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/9ff4033aeb88c066276a29640dfb7992.jpeg',
    },
  ];

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Dava Nasr - Graphic Designer/Brand Developer",
    "description": "Portfolio showcasing creative graphic design projects including Wild Cherry, Le Veau d'Or, Le Rock, and Frenchette by Dava Nasr",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
    "mainEntity": {
      "@type": "Person",
      "name": "Dava Nasr",
      "jobTitle": "Graphic Designer",
      "email": "davagraphiste@gmail.com",
      "hasOccupation": {
        "@type": "Occupation",
        "name": "Graphic Designer"
      }
    },
    "hasPart": projects.map(project => ({
      "@type": "CreativeWork",
      "name": project.title,
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}${project.link}`,
      "image": project.image,
      "creator": {
        "@type": "Person",
        "name": "Dava Nasr"
      }
    }))
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="Dava Nasr - Graphic Designer/Brand Developer"
        description="Portfolio showcasing creative graphic design projects including Wild Cherry, Le Veau d'Or, Le Rock, and Frenchette by Dava Nasr"
        keywords="graphic designer, brand development, creative design, illustration, portfolio, Wild Cherry, Le Veau d'Or, Le Rock, Frenchette"
        canonicalUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        schemaData={schemaData}
      />
      
      <Header />

      {/* Hero Section */}
      <section className="bg-black py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl sm:text-4xl md:text-6xl lg:text-8xl xl:text-9xl font-bold text-white mb-8 tracking-wide">
            davagraphiste
          </h1>
        </div>
      </section>

      {/* Project Tiles */}
      <section className="py-6 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {projects.map((project) => (
              <article key={project.id} className="text-center">
                <Link to={project.link} className="block group cursor-pointer">
                  <div className="bg-gray-900 border border-gray-700 overflow-hidden hover:shadow-lg transition-all duration-300 hover:border-gray-500 aspect-square mb-2 w-full md:mb-6 md:max-w-sm md:mx-auto">
                    <div className="relative h-full">
                      <img
                        src={project.image}
                        alt={`${project.title} project by Dava Nasr`}
                        title={`${project.title} - Creative Design Project`}
                        className={`w-full h-full ${
                          project.id === 1
                            ? 'object-cover object-center scale-200'
                            : project.id === 2
                            ? 'object-bottom'
                            : project.id === 3
                            ? 'object-[center_10%]'
                            : project.id === 4
                            ? 'object-cover object-top'
                            : 'object-cover object-top'
                        }`}
                      />
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <div className="text-center">
                          <div className="flex items-center justify-center text-white">
                            <span className="font-medium text-xs md:text-base">View Project</span>
                            <i className="ri-arrow-right-line ml-1 w-3 h-3 flex items-center justify-center group-hover:translate-x-1 transition-transform md:ml-2 md:w-5 md:h-5"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
                <h2 className="text-xl font-bold text-white tracking-wide md:text-3xl">{project.title}</h2>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
